/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Faq_1_QuestionInputs */

const en_svc_rag_faq_1_question = /** @type {(inputs: Svc_Rag_Faq_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is RAG, in plain terms?`)
};

const lv_svc_rag_faq_1_question = /** @type {(inputs: Svc_Rag_Faq_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas ir RAG, vienkāršiem vārdiem?`)
};

/**
* | output |
* | --- |
* | "What is RAG, in plain terms?" |
*
* @param {Svc_Rag_Faq_1_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_faq_1_question = /** @type {((inputs?: Svc_Rag_Faq_1_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Faq_1_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_faq_1_question(inputs)
	return en_svc_rag_faq_1_question(inputs)
});